var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStrokeJustice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "justice 1",
    clipPath: "url(#clip0_2_31344)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.23436 13.5063C8.23436 15.5861 6.5484 17.2722 4.46852 17.2722C2.38897 17.2722 0.702637 15.5862 0.702637 13.5063H8.23436Z",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.7661 13.5063C15.7661 15.5861 17.4524 17.2722 19.532 17.2722C21.6118 17.2722 23.2978 15.5861 23.2978 13.5063H15.7661Z",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.702637 13.5063L4.46848 5.97461L8.23436 13.5063",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.2978 13.5063L19.532 5.97461L15.7661 13.5063",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.0005 5.97408C12.8324 5.97408 13.5068 5.29967 13.5068 4.46775C13.5068 3.63583 12.8324 2.96143 12.0005 2.96143C11.1685 2.96143 10.4941 3.63583 10.4941 4.46775C10.4941 5.29967 11.1685 5.97408 12.0005 5.97408Z",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M10.4941 4.46826H5.9751L4.46873 5.97464L2.9624 4.46826",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M13.5066 4.46826H18.0256L19.532 5.97464L21.0383 4.46826",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M5.97485 23.2973C9.30046 23.2973 12.0002 20.5974 12.0002 17.272C12.0002 20.5974 14.7003 23.2973 18.0256 23.2973H5.97485Z",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M12.0002 5.97461V17.2722",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.0002 0.702148V2.96166",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M4.46851 23.2974H19.532",
    stroke: "white",
    strokeWidth: 1.40634,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_31344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0015,
    height: 24.0015,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStrokeJustice);
export default __webpack_public_path__ + "static/media/icon-stroke-justice.f6f1bc8211db9640a356e67bafd4222d.svg";
export { ForwardRef as ReactComponent };